import React from 'react';
import { useTranslation } from 'react-i18next';
import { Lock, Unlock } from 'lucide-react';

/** Lock toggle used on each Scenario variable row. */
export const LockToggle = ({ locked, onToggle, label, testId }) => {
  const { t } = useTranslation();
  const Icon = locked ? Lock : Unlock;
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onToggle}
      aria-label={locked ? t('scenario.unlock') : t('scenario.lock')}
      title={locked ? t('scenario.locked') : t('scenario.lock')}
      className={`inline-flex items-center gap-1 px-2 h-6 rounded-md text-[10px] font-semibold transition-colors ${
        locked
          ? 'bg-amber-100 dark:bg-amber-500/15 text-amber-700 dark:text-amber-300'
          : 'bg-slate-100 dark:bg-slate-800 text-slate-500 dark:text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-700'
      }`}
    >
      <Icon className="w-3 h-3" />
      <span className="uppercase tracking-wider">{label}</span>
    </button>
  );
};

export default LockToggle;
